if($('.type-detail').length){
    $(".availability-value .availability-label").each(function() {
        $(this).html(function(){
          return $(this).html().replace("Zvolte variantu", "Dle varianty");
        })
    })
    $('.delivery-time').each(function() {
        $(this).html(function(){
          return $(this).html().replace("Zvolte variantu", "Dle varianty");
        })
    })
    if($('.p-info-wrapper .availability-label').text().trim() === 'Na dotaz' || $('.p-info-wrapper .availability-label').text().trim() === 'Na otázku'){
        $('.sold-out').hide();
        $('.p-final-price-wrapper').hide();
        $('.p-info-wrapper').append('<div class="kosik"></div>');
        $('.kosik').append($('a.link-icon.chat').clone())
    }
    else{
        $('.p-info-wrapper').append('<div class="availRow"></div><div class="kosik"></div>')
    }

    
    if($('.delivery-time').length){
        $('.delivery-time').closest('tr').hide();
        $('.availRow').append('<div class="deliveryDate">Můžeme doručit do: <strong>'+$('.delivery-time').html()+'</strong></div>')
        $('.availRow').append($('.delivery-time').closest('tr').find('.shipping-options'))
    }
    else{
        $('.availRow').append($('.shipping-options'))
        
    }
    $('.availRow').append($('.availability-value'))

    $('.basic-description table').wrap('<div class="overflow-table"></div>')
    $('.p-image-wrapper').append($('.product-top>div:not(".col-lg-6") .flags'))
    $('.p-info-wrapper').append($('.p-detail-inner-header h1').clone())

    $('.p-info-wrapper').append($('.p-detail-info').clone())
  
   
    $('.kosik').append($('.p-final-price-wrapper'))
    $('.kosik').append($('.add-to-cart'));
    if($('.p-info-wrapper .detail-parameters tbody tr').length>0){
        $('.p-info-wrapper .detail-parameters').addClass('customTable')
    }
if($('.surcharge-list, .variant-list').length){
  
    if(!$('#simple-variants').length){
        var requiredGroups = [];   // obsahuje ID skupin, které jsou "required"
        var $requiredStatus;       // odkaz na prvek, do kterého se bude psát informace


        if($('.variant-list, .surcharge-list').length>0){
            $('.p-info-wrapper .detail-parameters tr').first().before('<tr><td colspan="2"><div class="h2" style="margin-bottom:15px;">'+nadpisKonfigurace+'</div></td></tr>')
            $('.variant-list select, .surcharge-list select').each(function(){
                if($(this).closest('.surcharge-list').find('th .show-tooltip').length){
                    var listTootip = $(this).closest('select').find('th .show-tooltip').attr('title')
                }
                else{
                    listTootip = ''
                }
                var requiredclass = '';
                if ($(this).closest('select').prop('required')) {
                    requiredclass = 'required';
                }
                var optionLength = $(this).find('option').length
                var data_parameter_id = $(this).data('parameter-id')

                var html_var = '<div class="custom-variant" data-groupId="'+data_parameter_id+'"><div class="h3 '+requiredclass+'"><span></span>'+$(this).attr('data-parameter-name')+'</div>'
                html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
                $(this).find('option').each(function(){
                    var data_value = $(this).attr('value')
                    if($(this).closest('td').find('select[name*="parameterValueId"]').length){
                        if ($.isNumeric($(this).val())) {
                            var textsplit = $(this).text().split('+')
                            html_var += '<div class="variant haveVariant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<div class="text">'
                            if(typeof textsplit[1] === 'undefined'){
                                html_var += textsplit[0]
                            }
                            else{
                                html_var += textsplit[0]+' (+'+textsplit[1]+')'
                            }
                          
                            if(listTootip !== ''){
                                if(textsplit[1] !== '0 Kč'){
                                    html_var += '<span class="show-tooltip question-tooltip" title="'+listTootip+'">?</span>'
                                }
                            }
                            html_var += '</div>'
                            html_var += '</div>'
                        }
                    }
                    else{
                        if ($.isNumeric($(this).val())) {
                            var textsplit = $(this).text().split('+')
                            html_var += '<div class="variant haveSurcharge" title="'+$(this).text()+'" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<div class="image"><img src="/user/documents/upload/priplatky/'+data_parameter_id+'/'+data_value+'.jpg?v='+new Date().getMinutes()+'" alt="'+$(this).text()+'"></div>'
                            html_var += '<span class="text">'+$(this).text().split('+')[0]+'</span><span class="price">'+$(this).text().split('+')[1]+'</span>'
                            html_var += '</div>'
                        }
                    }
                    
                })
                html_var += '</div>'
                html_var += '</div>'
                $(this).after(html_var)
                $(this).closest('.variant-list select, .surcharge-list select').hide()
               $(this).closest('.variant-list span, .surcharge-list span').hide()
                if (requiredclass === 'required') {
                    requiredGroups.push(data_parameter_id);
                }
            })
    
            var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
            for (var parentKey in necessaryVariantData) {
                if (necessaryVariantData.hasOwnProperty(parentKey)) {
                    var variant = necessaryVariantData[parentKey];
                    console.log(variant)
                    $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').addClass('haveImage').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-')).append('<div class="image"><img src="'+variant.variantImage.detail_small+'" alt="'+variant.name+'"></div>')
                
                }
            }
            requiredGroups = Array.from(new Set(requiredGroups));
            var totalRequiredCount = requiredGroups.length;

            // Vložíme stavový element za .add-to-cart
            $requiredStatus = $('<div class="required-status"></div>');
            $('.surcharge-list').first().find('td').prepend($requiredStatus);
            }
    }
}
    


    function updateRequiredStatus() {
            var completedCount = 0;
            requiredGroups.forEach(function(groupId){
                var $selected = $('.custom-variant-wrap[data-param-id="'+ groupId +'"] .variant.selected');
                if ($selected.length) {
                    completedCount++;
                }
            });
            if (totalRequiredCount === 0) {
             //   $requiredStatus.text('Nemáte žádné povinné přípatky.');
                return;
            }
            if (completedCount === totalRequiredCount) {
               
                $requiredStatus.text('Všechny povinné příplatky jsou vyplněny.');
                $('body').removeClass('disable-add-to-cart')
            } else {
                $requiredStatus.text('Vybráno ' + completedCount + ' z ' + totalRequiredCount + ' povinných příplatků.');
                $('body').addClass('disable-add-to-cart')
            }
    }
    $(document).on('click', '.custom-variant-wrap .variant', function(e) {
        var $this = $(this);
        var $wrap = $this.closest('.custom-variant-wrap');
        $wrap.find('.variant').removeClass('selected');
        $this.addClass('selected');
        updateRequiredStatus();
    });
    if($('.surcharge-list, .variant-list').length){
        updateRequiredStatus();
    }

    $('html').on('click', '.custom-variant .h3', function(){
        $(this).closest('.custom-variant').toggleClass('active');
    });
    $(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');

        
            // Původní chování pro ostatní případy
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
                return $(this).attr('value') == variantData;
            }).change().prop("selected", true);
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).addClass("active"); 
        
    
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
    
       // $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
       // $(this).addClass("active");    
    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
        $(this).closest('.custom-variant').addClass('haveParametr');
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value');
            const variantParameterId = $(this).data('parameter-id');
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active");
            }
            else{
                $(this).removeClass("unavailable");
            } 
        });
    });

    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-variant-wrap .variant').removeClass('unavailable')
    })
    $(document).ready(function(){
        $('.custom-variant .variant[data-param-val="51-135"]').trigger('click');
        $(".custom-variant-wrap").each(function() {
            var $variants = $(this).find("div.variant");
            if ($variants.length === 1) {
             // $variants.addClass("active");
            }
          });
        var urlParams = new URLSearchParams(window.location.search);
        var parameterValueId = urlParams.get("parameterValueId");
        var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
        if ($divToHighlight.length > 0) {
            $divToHighlight.addClass("active");
        }
    })

}